import { QueryFunctionContext } from "react-query";
import api from "./capTableApi";
import { Type3CompanyPageModel } from "../types/T3CompanyModel";

export async function getType3CompanyOverviewDetails(
  context: QueryFunctionContext
): Promise<Type3CompanyPageModel> {
  const cin = context.queryKey[1];
  const token: string = (context.queryKey[2] as string) || "";
  const isPrivate = token !== "";
  return api
    .get(`v1/company/t3Company`, {
      params: {
        isPrivate,
        token,
        cin,
      },
    })
    .then((res) => res.data.data);
}
